import './PageAuthor.css'

export default function PageAuthor() {
  return (
    <a href="https://www.linkedin.com/in/mhamad-raad">
      <p>by Mhamad Raad</p>
    </a>
  );
}
